export default __webpack_public_path__ + "static/media/questionmark.a3f6fccc.svg";